import React, { useCallback, useMemo } from 'react';
import ContentLoader from 'react-content-loader';
import { geoPath } from 'd3-geo';
import { geoMiller } from 'd3-geo-projection';
import world from './world.topo.json';
import { feature } from 'topojson-client';

function SkeletonMap(props: any): any {
  const { width, height } = props;

  const features = useMemo(() => {
    // Parse TopoJSON to a GeoJSON FeatureCollection
    return feature(world, world.objects.world);
  }, []);

  /**
   * Creates a Miller projection, centered in the width/height of the
   * parent element, rendering with a low precision to improve performance.
   * See: https://github.com/d3/d3-geo#projections
   * @returns {Function} A configured geoMiller projection instance.
   */
  const projection = useCallback(
    geoMiller()
      .precision(0.1)
      .fitWidth(width * 0.95, features)
      .center([0, 15])
      .translate([width / 2, height / 2]),
    [width, height]
  );

  /**
   * Creates or reuses an instance of geoPath, using the projection to render.
   * See: https://github.com/d3/d3-geo#geoPath
   * @returns {Function} A configured geoPath instance.
   */
  const path = useCallback(geoPath().projection(projection), [projection]);

  return (
    <ContentLoader
      title="Loading territory data..."
      width={width}
      height={height}
    >
      <path d={path(features) as string} />
    </ContentLoader>
  );
}

export default SkeletonMap;
